import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type SetApiConfigurationResponseType = {};

export type SetApiConfigurationParams = {
  braze_api_key: string;
};

export const useSetApiConfiguration = (
  options?: MutationOptions<
    SetApiConfigurationResponseType,
    SetApiConfigurationParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async (params) => {
      const { data } = await api.post<ApiResponse<SetApiConfigurationResponseType>>(
        '/configuration',
        params
      );

      return data.data;
    },
    ...options,
  });
